import React, { useState } from "react";

/**
 * Legal/long text collapsed to a few lines with a "Leer más" toggle.
 * `preventDefault` on the toggle keeps it usable inside <label> wrappers
 * (otherwise the click would also toggle the label's checkbox).
 */
const ExpandableText = ({ text, className = "" }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div>
      <p className={`${className} ${expanded ? "" : "line-clamp-2"}`}>
        {text}
      </p>
      <button
        type="button"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          setExpanded((prev) => !prev);
        }}
        className="mt-1 text-xs font-semibold text-blue-900 hover:text-blue-950 transition-colors"
      >
        {expanded ? "Leer menos" : "Leer más..."}
      </button>
    </div>
  );
};

export default ExpandableText;
